export const getCollectionsClient = async () => {
    const options = { method: "GET", headers: { accept: "application/json" } };
    const url = 'https://us-central1-admin-novoos.cloudfunctions.net/app/api/marcas/5m9CtXq7mFbLu9Q1Gmcd'
    const res = await fetch(url, options)
    const data = await res.json()
    
    const collectionOrder = Object.values(data.contracts);
    return collectionOrder
};